// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadItem_container__3AijD","label":"UploadItem_label__1J4wy"};